// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useMemo, useState } from 'react';
import UtilityAutomationApiClient from '../utils/UtilityAutomationApiClient';
import { useUserState } from './UserContext';
import { UtilityAutomationApiContext } from './UtilityAutomationApiContext';

export const UtilityAutomationApiClientProvider = ({ children }: React.PropsWithChildren) => {
  const { loggedInUser } = useUserState();

  const [utilityAutomationApiClient, setApiClient] = useState<
    UtilityAutomationApiClient | undefined
  >(undefined);

  useMemo(() => {
    const create = () => {
      if (loggedInUser) {
        setApiClient(new UtilityAutomationApiClient(loggedInUser));
      }
    };
    create();
  }, [loggedInUser]);

  return (
    <UtilityAutomationApiContext.Provider value={utilityAutomationApiClient}>
      {children}
    </UtilityAutomationApiContext.Provider>
  );
};
